<template>
  <vue-tabs>
    <v-tab title="Rapport - Succès">
      <div class="data-list-container">
        <vs-table ref="table" max-items="10" :data="success_data">
          <template slot="thead">
            <vs-th>Nom</vs-th>
            <vs-th>Prénom</vs-th>
            <vs-th>Téléphone</vs-th>
            <vs-th>Email notification</vs-th>
            <vs-th>Sms notification</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{ data }">
            <tbody ref="tbody">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.lastname }}</vs-td>
                <vs-td>{{ tr.firstname }}</vs-td>
                <vs-td>{{ tr.phone }}</vs-td>
                <vs-td>Oui</vs-td>
                <vs-td>Oui</vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </v-tab>
    <v-tab title="Rapport - Erreur">
      <div class="data-list-container">
        <vs-table ref="table" max-items="10" :data="wrong_data">
          <template slot="thead">
            <vs-th>Nom</vs-th>
            <vs-th>Prénom</vs-th>
            <vs-th>Téléphone</vs-th>
            <vs-th>Raison</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{ data }">
            <tbody ref="tbody">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.lastname }}</vs-td>
                <vs-td>{{ tr.firstname }}</vs-td>
                <vs-td>{{ tr.phone }}</vs-td>
                <vs-td>{{ tr.reason }}</vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </v-tab>
  </vue-tabs>
</template>

<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.css";

export default {
  name: "ListPacksCertifiedUsersBashImportHistory",

  components: { VueTabs, VTab },
  data: () => ({
    success_data: [],
    wrong_data: [],
  }),
  methods: {
    loadHistory() {
      this.$vs.loading();
      let id = this.$route.params.id;
      this.$http
        .get("/users/bash/file/history/" + id)
        .then((response) => {
          this.success_data = response.data.success_data;
          this.wrong_data = response.data.wrong_data;

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.loadHistory();
  },
};
</script>

<style lang="scss" scoped>
</style>